// extracted by mini-css-extract-plugin
export default {"empty":"TestResults_empty__hQBx2"};